module.exports = __webpack_public_path__ + "assets/img/media_9.4e13cf6c.png";